// The deal as one statement, on the buyer PO's quantity: what it earns, what it costs landed, and
// what is left. The engine sets the rows out and totals them; nothing is added up here.
// Where a row is one quantity at one rate, the quantity, its unit and the rate are shown.
// A cost is a plain figure, as on a statement; a margin below zero is bracketed, not tinted.

import { money } from './format.js';

const EXACT = { exact: true };
const RATE = { asRate: true };

const quantity = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

const ROW_CLASS = {
  DETAIL: 'is-detail',
  SUBTOTAL: 'is-subtotal',
  TOTAL: 'is-total',
};

export default function DealSummary({ result }) {
  const s = result.summary;
  const c = result.currency;
  return (
    <div className="table-scroll">
      <table className="data-table econ-summary">
        <thead>
          <tr>
            <th className="plain">Item</th>
            <th className="plain num">Qty</th>
            <th className="plain">Unit</th>
            <th className="plain num">Unit $</th>
            <th className="plain num">$/MT</th>
            <th className="plain num">Value</th>
          </tr>
        </thead>
        <tbody>
          {s.rows.map((row) => (
            <tr key={row.label} className={ROW_CLASS[row.kind]}>
              <td>{row.label}</td>
              <td className="num">{row.quantity == null ? '' : quantity.format(Number(row.quantity))}</td>
              <td>{row.unit ?? ''}</td>
              <td className="num">{row.unit_rate == null ? '' : money(row.unit_rate, c, RATE)}</td>
              <td className="num">{money(row.per_mt, c, EXACT)}</td>
              <td className="num">{money(row.value, c)}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={4}>Net margin %</td>
            <td className="num" colSpan={2}>{s.net_margin_pct}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
